import React, { Component } from "react";
import moment from 'moment';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress from "@material-ui/core/CircularProgress";

const backend = require('../../config.js').backend;

class Approved_Ministry_Donations_Report extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reports: {},
            allDesigs: {},
            report_buttons: {},
            staffId: sessionStorage.getItem('id_e'),
            redirectLogout: false
        }

    }


    componentDidMount() {

        this.getDesigs();
        this.getReports();
    }


    // get all pending pdf files
    getReports = () => {

        var status = 'approved'
        fetch(backend + `api/v1/ministrydonationsreport?status=` + status, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    console.log(data.error);

                    if (data.redirect) {
                        this.setState({ redirectLogout: true })
                        window.location.reload(false);
                    }
                    else if (data.error === 'no return from set approvedFiles') {
                        this.setState({ reports: {} });
                    }
                    else {
                        NotificationManager.error('ERROR:' + data.error);
                    }
                }

                else {
                    this.setState({ reports: data.reports });
                }


            })
            .catch(error => {
                console.log(error);
            });


    }

    getDesigs = () => {

        fetch(backend + `api/v1/gift/alldesignames`, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {
                // console.log(data);
                if (data.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else {
                    this.setState({ allDesigs: data })
                }
            })
            .catch((err) => {
                console.log('getDesigs', err);
            })

    }


    getPdfDataStream = (filename) => {

        fetch(backend + `api/v1/ministrydonationsreport/pdf?filename=` + filename, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {

                if (data.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (data.error) {
                    NotificationManager.error('Getting PDF data error:' + data.error.code);
                }
                else {
                    this.setState({ renderPdf: data.data, checking: filename });
                }
            })
            .catch((err) => {
                NotificationManager.error('Getting PDF data error:' + err.toString());

            })
    }


    handleCheck = report => {

        this.getPdfDataStream(report.fileName);

    }


    handleDelete = (filename, desigId, index) => {

        // double check with user
        var answer = window.confirm("Are you sure you want to delete the approved report " + filename + " ?")

        if (answer) {
            this.deleteOneFile(filename, desigId, index);

            if (this.state.checking && this.state.checking === filename) {
                this.setState({ renderPdf: undefined })
            }
        }

    }


    deleteOneFile = (filename, desigId, index) => {

        // Delete it from Redis database
        var { staffId } = this.state;
        var url = `api/v1/ministrydonationsreport/` + staffId + `?filename=` + filename;

        fetch(backend + url, {
            method: 'DELETE',
            credentials: "include"
        })
            .then(res => res.json())
            .then(res => {

                if (res.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (res.status === 404) {
                    NotificationManager.warning(res.message, '', 10000);
                    this.removeReportFromList(desigId, index); // Delete a report from frontend display
                }
                else if (res.status === 500) {
                    NotificationManager.error(res.message, '', 10000);
                }
                else {
                    this.removeReportFromList(desigId, index); // Delete a report from frontend display
                }

            })
            .catch(err => console.log(err));

    }

    removeReportFromList = (desigId, index) => {

        let { reports } = this.state;
        let reportList = reports[desigId];

        reportList.splice(index, 1);

        if (reportList.length === 0) { // no report left, delete the ministry record
            delete reports[desigId]
            this.setState({ reports: reports });
        }
        else {
            reports[desigId] = reportList;
            this.setState({ reports: reports });
        }

    }


    handleSend = (filename, desigId, index) => {

        var { report_buttons } = this.state;
        report_buttons[filename] = 'disabled';
        this.setState({ report_buttons: report_buttons });

        this.sendOneFile(filename, desigId, index);

    }


    handleEmailAll = reports => {

        const _this = this;
        var { report_buttons } = this.state;


        // eslint-disable-next-line array-callback-return
        Object.keys(reports).map(function (ministryId) {
            var oneMinistryReportList = reports[ministryId]
            // eslint-disable-next-line array-callback-return
            oneMinistryReportList.map((report, index) => {

                const fileName = report.fileName;
                report_buttons[fileName] = 'disabled';
                _this.sendOneFile(report.fileName, ministryId, index);

            })
        });

        this.setState({ report_buttons: report_buttons });

    }


    sendOneFile = (filename, desigId, index) => {
        var { report_buttons } = this.state;
        var { staffId } = this.state;

        var url = `api/v1/ministrydonationsreport/pdf/` + staffId + `/` + desigId + `?filename=` + filename;

        // console.log(url)

        fetch(backend + url, {
            method: 'DELETE',
            credentials: "include"
        })
            // .then(res => res.json())
            .then(res => {

                if (res.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (res.status === 500) {
                    delete report_buttons[filename];
                    this.setState({ report_buttons: report_buttons })
                    NotificationManager.error(filename + ' cannot be sent, Error: ' + res.message);
                }
                else {
                    this.updateReportStatusInList(desigId, index); // Change the status to green tick
                }

            })
            .catch(err => {
                console.log(err)
                delete report_buttons[filename]
                this.setState({ report_buttons: report_buttons })
            });

    }


    updateReportStatusInList = (desigId, index) => {

        let { reports } = this.state;
        let reportList = reports[desigId];
        let report = reportList[index];

        report.status = 'sent';
        reportList[index] = report
        reports[desigId] = reportList;

        this.setState({ reports: reports });

    }

    renderEmailButtons = (fileName, desigId, index) => {
        var { report_buttons } = this.state;
        let content;

        if (report_buttons[fileName] === 'disabled') {
            content = (<button type="button" className="btn btn-primary submit"
                onClick={() => this.handleSend(fileName, desigId, index)} disabled>
                Sending
            </button>)
        }
        else {
            content = (<button type="button" className="btn btn-primary submit"
                onClick={() => this.handleSend(fileName, desigId, index)}>
                Send Out
            </button>)
        }

        return content;

    }

    renderReportButtons = (report, desigId, index) => {

        // console.log(report)

        let fileName = report.fileName;
        let content;


        if (report.status === 'approved') {

            content = (<td>
                {this.renderEmailButtons(fileName, desigId, index)}
                <VisibilityIcon onClick={() => this.handleCheck(report)} />
                <DeleteIcon onClick={() => this.handleDelete(fileName, desigId, index)} />
            </td>)

        }

        else {

            content = (<td style={{ color: 'green' }}>Sent</td>)

        }

        return content

    }

    renderReportRow = (report, index, desigId) => {

        // console.log('renderReportRow', report, index, desigId)

        if (index === 0) {
            return null
        }
        else {
            return (
                <tr key={index}>
                    <td>{report.fileName}</td>
                    <td>{report.status}</td>
                    <td>{report.approverName}</td>
                    <td>{moment(report.approveDate, 'YYYYMMDDHHmmss').format('DD-MMM-YYYY')}</td>
                    {this.renderReportButtons(report, desigId, index)}
                </tr>
            )
        }


    }


    renderReports = (reports, desigId) => {


        let length = reports.length;
        var { allDesigs } = this.state;
        var DesigName = allDesigs[desigId];
        var first_report = reports[0]; // render first row with rowspan
        var approveDate = first_report.approveDate;

        const init_index = 0;

        return (
            <React.Fragment key={init_index}>
                <tr key={init_index}>
                    <td className='multiRow' rowSpan={length}>{DesigName}</td>
                    <td>{first_report.fileName}</td>
                    <td>{first_report.status}</td>
                    <td>{first_report.approverName}</td>
                    <td>{moment(approveDate, 'YYYYMMDDHHmmss').format('DD-MMM-YYYY')}</td>
                    {this.renderReportButtons(first_report, desigId, init_index)}
                </tr>
                {length > 1 ?
                    reports.map((r, i) => this.renderReportRow(r, i, desigId))
                    :
                    null
                }
            </React.Fragment>
        )

    }



    renderMinistryList = _ => {
        var { reports } = this.state;
        var { isButtonDisabled } = this.state;

        // loop reports to get all designIds and display it in table
        if (reports && Object.keys(reports).length) {
            return (
                <div>

                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Designation Name</th>
                                <th>Files</th>
                                <th>Status</th>
                                <th>Approver</th>
                                <th>Approved Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {Object.keys(reports).map((desigId, i) => (
                                this.renderReports(reports[desigId], desigId)
                            ))}
                        </tbody>

                    </table>

                    {(isButtonDisabled) ?
                        <button
                            className="btn btn-primary submit"
                            onClick={() => this.handleEmailAll(reports)} disabled>
                            Email All Reports
                        </button>
                        :
                        <button
                            className="btn btn-primary submit"
                            onClick={() => this.handleEmailAll(reports)}>
                            Email All Reports
                        </button>
                    }



                </div>

            )
        }

        else if (reports && (Object.keys(reports).length === 0)) {
            return (<h4 className='center'>No data returned</h4>)
        }

        else {
            return (
                <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
                  <h4 className='title'>Loading... This may take a while... </h4>
                  <CircularProgress/>
                </div>)
        }

    }

    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let ministryList = this.renderMinistryList();

        let content = (
            <div className="ministry-donations-report-sendout">
                <h3 className="title">Approved Ministry Donations Report</h3>

                <div className="report-table">
                    {ministryList}
                </div>


                {this.state.renderPdf ?
                    <iframe
                        title="frame"
                        width="1000px"
                        height="600px"
                        src={`data:application/pdf;base64,` + this.state.renderPdf}
                    /> : null}

                <NotificationContainer />

            </div>
        )

        return (content)

    }

}

export default Approved_Ministry_Donations_Report;
